import React, { useEffect } from "react";
import ReactGA from 'react-ga4';

import CreateCommunity from "../../Account/CreateCommunity/createCommunity";
import Header from "../../../components/Header/header";

const NewCommunity = () => {
    
    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/create-new-community` })
    }, [])

    return (
        <>
            <Header title='New Community'  />
            <CreateCommunity url='/new-community'/>
        </>
    )
}

export default NewCommunity;